import React, { useEffect } from "react";
import { MainButton, TextRegular, Title } from "../../styles/GlobalStyledComponents";

import DataMiss from "../../assets/images/DataMiss.svg";
import { InvalidIbanImg } from "./InvalidIbanStyledComponents";


interface InvalidIbanProps {
    selectBankreader: () => void;
    loadingEvent: (data: boolean) => void;
}

export const InvalidIban: React.FC<InvalidIbanProps> = ({ loadingEvent, selectBankreader }) => {

    useEffect(() => {
        loadingEvent(false);
    }, [loadingEvent]);

    return <>
        <Title id="invalid-iban-title">¡Aviso importante!</Title>
        <TextRegular $fontSize={14} $align='center'>Es necesario que el cliente acceda de nuevo utilizando credenciales de un banco nacional.</TextRegular>
        <TextRegular $fontSize={14} $align='center'>Hemos detectado que el banco que ha seleccionado tiene IBAN extranjero y no podremos domiciliar allí sus cuotas.</TextRegular>
        <InvalidIbanImg src={DataMiss}></InvalidIbanImg>
        <MainButton id="unknown-error-return-btn" onClick={selectBankreader}>Seleccionar otro banco</MainButton>
    </>
};